export const ON_CHANGE_DELAY = 500;
export default ON_CHANGE_DELAY;
